import { Injectable } from "@angular/core";
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { ConfirmAlertComponent } from "../components";

@Injectable({
    providedIn: 'root',
})
export class ConfirmAlertService {
    constructor(private modalService: BsModalService) { }

    showConfirmAlert(confirmCallback: (isConfirmed: boolean) => void, message: string = ''): BsModalRef<ConfirmAlertComponent> {
        const options: ModalOptions = {
            class: 'modal-default modal-dialog-centered',
            initialState: {
                message: (message || 'Do you really want to continue?'),
                callback: confirmCallback
            }
        };

        return this.modalService.show(ConfirmAlertComponent, options);
    }
   

}